export var GOOGLE_OAUTH_INVALID_GRANT = 'invalid_grant';
export var GOOGLE_INTEGRATION_INVALID_GRANT_EVENT_TYPE = 'googleIntegrationInvalidGrant';
/** Install/reconnect: missing admin scopes or Directory access (non-admin installer). */
export var GOOGLE_WORKSPACE_ADMIN_PERMISSION_REQUIRED = 'Google Workspace admin permission required. Please contact your admin to authorize the app';
/** Sign-in/install: consumer Google account with no Workspace hosted domain. */
export var GOOGLE_WORKSPACE_ACCOUNT_REQUIRED = 'Only Google Workspace accounts are allowed';
/** @deprecated Prefer GOOGLE_WORKSPACE_ADMIN_PERMISSION_REQUIRED; kept for older clients. */
export var GOOGLE_WORKSPACE_ADMIN_PERMISSION_REQUIRED_LEGACY = 'Not access to this resource';
var NOT_AUTHORIZED_MESSAGE = 'Not Authorized to access this resource/api';
var getHttpStatus = function (err) {
    var _a, _b;
    if (typeof err.code === 'number') {
        return err.code;
    }
    if (typeof err.status === 'number') {
        return err.status;
    }
    if (typeof ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 'number') {
        return err.response.status;
    }
    if (typeof ((_b = err.response) === null || _b === void 0 ? void 0 : _b.statusCode) === 'number') {
        return err.response.statusCode;
    }
    return undefined;
};
var getErrorMessage = function (err) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var message = (_a = err.message) !== null && _a !== void 0 ? _a : '';
    var dataError = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error;
    if (typeof dataError === 'string') {
        return "".concat(message, " ").concat(dataError, " ").concat((_f = (_e = (_d = err.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.error_description) !== null && _f !== void 0 ? _f : '');
    }
    if (dataError && typeof dataError === 'object') {
        return "".concat(message, " ").concat((_g = dataError.message) !== null && _g !== void 0 ? _g : '', " ").concat((_h = dataError.status) !== null && _h !== void 0 ? _h : '');
    }
    return "".concat(message, " ").concat((_l = (_k = (_j = err.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.error_description) !== null && _l !== void 0 ? _l : '');
};
export var isGoogleOAuthInvalidGrantError = function (error) {
    var _a, _b, _c;
    if (!error || typeof error !== 'object') {
        return false;
    }
    var err = error;
    var responseError = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error;
    if (responseError === GOOGLE_OAUTH_INVALID_GRANT) {
        return true;
    }
    var message = (_c = err.message) !== null && _c !== void 0 ? _c : '';
    return (message.includes(GOOGLE_OAUTH_INVALID_GRANT) ||
        message.includes('Token has been expired or revoked'));
};
/** Admin SDK / API 401 when Workspace access was revoked or the install was deleted. */
export var isGoogleApiNotAuthorizedError = function (error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    var err = error;
    var status = getHttpStatus(err);
    var combinedMessage = getErrorMessage(err);
    if (combinedMessage.includes(NOT_AUTHORIZED_MESSAGE)) {
        return true;
    }
    if (status === 401) {
        return true;
    }
    return (combinedMessage.includes('AUTH_ERROR') ||
        /not\s+authorized/i.test(combinedMessage));
};
/** Permanent auth failures — stop calling Google for this installation. */
export var isGoogleAuthFailureError = function (error) {
    return isGoogleOAuthInvalidGrantError(error) || isGoogleApiNotAuthorizedError(error);
};
var getClientErrorMessage = function (error) {
    var _a;
    if (!error || typeof error !== 'object') {
        return '';
    }
    return (_a = error.message) !== null && _a !== void 0 ? _a : '';
};
export var isGoogleWorkspaceAdminPermissionError = function (error) {
    var message = getClientErrorMessage(error);
    return (message.includes(GOOGLE_WORKSPACE_ADMIN_PERMISSION_REQUIRED) ||
        message.includes(GOOGLE_WORKSPACE_ADMIN_PERMISSION_REQUIRED_LEGACY) ||
        message.includes('No scope'));
};
export var isGoogleWorkspaceAccountRequiredError = function (error) {
    var message = getClientErrorMessage(error);
    return message.includes(GOOGLE_WORKSPACE_ACCOUNT_REQUIRED);
};
